import { str } from "@lit/localize";
//#region src/generated/locales/be.ts
var templates = {
	"pd.moreInfo.less": `Minder informatie`,
	"pd.moreInfo.more": `Meer informatie`,
	"pd.sidebar.collapse": `Zijbalk inklappen`,
	"pd.sidebar.expand": `Zijbalk uitklappen`,
	"pdContent.loadingstate.ariaLabel": `Laadproces`,
	"pdContent.loadingstate.ariaLoading": `Laden`,
	"pdContent.loadingstate.pleaseWait": `Even geduld, gegevens worden geladen`,
	"pdContent.loadingstate.syncState": `Gegevens worden gesynchroniseerd`,
	"pd.edit.content.edit": `Edit`,
	"pd.panel.viewer.aria.label": `Panel viewer`,
	"pd.panel.viewer.prev": `Previous panel`,
	"pd.panel.viewer.next": `Next panel`,
	"pd.panel.viewer.progress": `Panel navigation`,
	"pd.panel.viewer.panel": `Panel`,
	"pdContent.badgeItem.titlePlaceholder": `Titel`,
	"pdContent.badgeItem.descPlaceholder": `Beschreibung`,
	"pdContent.badgeItem.save": `Speichern`,
	"pdContent.badgeItem.cancel": `Abbrechen`,
	"pdContent.badgeItem.editTitle": `Bearbeiten`,
	"pdContent.badgeItem.editAria": `Badge bearbeiten`,
	"pdContent.badgeItem.removeTitle": `Entfernen`,
	"pdContent.badgeItem.removeAria": `Badge entfernen`,
	"pdContent.badgeItem.addTitle": `Hinzufügen`,
	"pdContent.badgeItem.addAria": `Badge hinzufügen`,
	"pdContent.badgeItem.deleteTitle": `Löschen`,
	"pdContent.badgeItem.deleteAria": `Badge löschen`,
	"pdContent.badgeOrder.error.required": `Mindestens eine Badge auswählen`,
	"pdContent.badgeOrder.error.min": str`Mindestens ${0} Badges auswählen`,
	"pdContent.badgeOrder.error.max": str`Maximal ${0} Badges erlaubt`,
	"pdContent.badgeOrder.activeLabel": `Ausgewählt`,
	"pdContent.badgeOrder.availableLabel": `Verfügbar`,
	"pdContent.badgeOrder.emptyActive": `Badges hierher ziehen`,
	"pdContent.badgeOrder.emptyAvailable": `Keine weiteren Badges`,
	"pdContent.badgeOrder.activeHint": `Werden in dieser Reihenfolge angezeigt`,
	"pdContent.badgeOrder.availableHint": `Ziehe hierher, um zu deaktivieren`,
	"pdContent.badgeOrder.create": `Hinzufügen`,
	"pdContent.badgeOrder.aiTrigger": `KI-Assistent öffnen`
};
//#endregion
export { templates };
